import { useState } from "react";
import { useFieldErrors, IFieldErrors } from "@common/hooks/useFieldErrors";
import { useTranslation } from "react-i18next";
import { IPersonCerts, IPersonFormData } from "../../models/IPerson";
import { IPersonCert } from "../../models/IPersonCert";
import { isBefore, parse } from "date-fns";

export type IUsePersonFormHook<TData> = (initialData?: TData) => {
    formData: TData;
    update: (values: Partial<TData>) => void;
    validate: (values: TData, requiredCerts?: Array<string>) => IFieldErrors<TData> | null;
    errors: IFieldErrors<TData>;
    hasErrors: boolean;
};

export const usePersonForm: IUsePersonFormHook<IPersonFormData> = (initialData = {}) => {
    const t = useTranslation().t;

    const [formData, setFormData] = useState<IPersonFormData>(initialData);
    const [fieldErrors, setErrors] = useFieldErrors<IPersonFormData>()

    const update = (values: IPersonFormData) => {
        setFormData((prevData) => ({ ...prevData, ...values }))
    };

    const validate = (values: IPersonFormData, requiredCerts: Array<string> = []) => {
        let errors: typeof fieldErrors = {};
        if (!values.firstname) {
            errors.firstname = t("Pakollinen");
        };
        if (!values.surname) {
            errors.surname = t("Pakollinen");
        };

        let certsData = values.certs
        if (certsData) {
            Object.keys(certsData).forEach((key) => {
                if (!requiredCerts.includes(key)) {
                    return
                }
                const cert = (certsData as IPersonCerts)[key];
                let certErrors: IFieldErrors<IPersonCert> = {}
                if (cert?.startsAt && !cert.endsAt) {
                    certErrors.endsAt = t("Pakollinen")
                }

                if (cert?.startsAt && cert?.endsAt) {
                    try {
                        let startsAtDate = parse(cert?.startsAt, "dd.MM.yyyy", new Date());
                        let endsAtDate = parse(cert?.endsAt, "dd.MM.yyyy", new Date());
                        if (isBefore(endsAtDate, startsAtDate)) {
                            certErrors.endsAt = t("Ei voi päättyä ennen alkamista")
                        }
                    } catch (error) { }
                }

                if (Object.keys(certErrors).length) {
                    errors.certs = { ...((errors as any).certs || {}), [key]: certErrors }
                }
            })
        };

        setErrors(errors);
        return Object.keys(errors).length ? errors : null;
    };

    return {
        formData,
        update,
        validate,
        errors: fieldErrors,
        hasErrors: Boolean(Object.keys(fieldErrors).length)
    }


};